/// <amd-module name="Build/Admin/Pool/Stores/MaintenanceJobsStore" />
import { Store } from "VSS/Reflux/Store";

import { TaskAgentPoolMaintenanceJob } from "DistributedTask/Client/Contracts/TaskAgent";

import { StoreStatus } from "Build/Admin/Common/Constants";

export interface IMaintenanceStoreState {
    jobs: TaskAgentPoolMaintenanceJob[];
    status: StoreStatus;
}


export class MaintenanceJobStore extends Store {
    public state: IMaintenanceStoreState = {
        jobs: [],
        status: StoreStatus.None
    };

    constructor() {
        super("MaintenanceJobStoreChanged");
    }

    public updateStatus = (status: StoreStatus): void => {
        this.state = {
            ...this.state,
            status
        };

        this.emitChanged();
    }

    public updateJobs = (jobs: TaskAgentPoolMaintenanceJob[]) => {
        this.state = {
            status: StoreStatus.Loaded,
            jobs: this._sortJobs(jobs)
        };

        this.emitChanged();
    }

    public updateJob = (job: TaskAgentPoolMaintenanceJob) => {
        const nonMatchingJobs = this.state.jobs.filter(j => j.jobId !== job.jobId);
        nonMatchingJobs.push(job);

        this.state = {
            ...this.state,
            jobs: this._sortJobs(nonMatchingJobs)
        };

        this.emitChanged();
    }

    private _sortJobs(jobs: TaskAgentPoolMaintenanceJob[]): TaskAgentPoolMaintenanceJob[] {
        return jobs.sort((a, b) => {
            return b.jobId - a.jobId;
        });
    }
}
